<app-ep-generic-dialog [dialogTitle]="title" (cancelClick)="closeButton ? back() : onCancel()">
  <ng-container dialog-content class="dialog-content">
    <div class="status-icon-dialog" *ngIf="status">
      <app-svg-icon src="./assets/icons/{{ status }}-icon.svg"></app-svg-icon>
    </div>

    <div class="meter-status" *ngIf="status" [innerHtml]="readingUploaded"></div>

    <div
      [ngClass]="{
        'status-description': status,
        description: !status,
        'description-sub': phoneNumber,
        'description-main': descriptionSubText && !phoneNumber
      }"
    >
      {{ description }}
      <span class="phoneNumber" *ngIf="phoneNumber"> {{ phoneNumber }} </span>
    </div>

    <div
      *ngIf="descriptionSubText"
      [ngClass]="{
        'status-description': status,
        description: !status,
        'description-sub': descriptionSubText,
        'description-main': descriptionSubText && !phoneNumber
      }"
    >
      {{ descriptionSubText }}
      <span class="emailAddress" *ngIf="emailAddress"> {{ emailAddress }} </span>
      <span *ngIf="descriptionSubText1" class="description-subtext"> {{ descriptionSubText1 }} </span>
    </div>

    <div *ngIf="descriptionSubText2" [ngClass]="{ 'status-description': status, description: !status, 'description-sub': descriptionSubText2 }">
      {{ descriptionSubText2 }}
    </div>
  </ng-container>

  <ng-container dialog-actions>
    <div class="flex-row gap-8 button-container">
      <button *ngIf="confirmText" class="ep-btn" [ngClass]="actionType === 'Delete' ? 'ep-btn-danger' : 'ep-btn-primary'" (click)="back()">
        {{ confirmText }}
      </button>
      <button *ngIf="declineText" class="ep-btn ep-btn-secondary decline-btn" (click)="onCancel()">
        {{ declineText }}
      </button>
    </div>
  </ng-container>
</app-ep-generic-dialog>
